import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import {
  MailOutline as MailIcon,
  Close as CloseIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import { useGetMailCliente } from "../hooks/useGetMail";
import { useEffect } from "react";
import { useReenviarPorMail } from "../hooks/useReenviarPorMail";

const ReenviarPorMail = ({ open, onClose, id, showToast }) => {
  const { execute: getMail, mail, loading } = useGetMailCliente();
  const { execute: reenviarPorMail, loading: loadingEnviar } =
    useReenviarPorMail();

  const handleConfirm = async () => {
    try {
      await reenviarPorMail(id);

      showToast("Comprobante reenviado correctamente", "success");

      onClose();
    } catch (err) {
      showToast("No se pudo reenviar el comprobante", "error");
    }
  };

  useEffect(() => {
    if (open) {
      getMail(id).catch(() => {
        showToast("Error al obtener el mail", "error");
        onClose();
      });
    }
  }, [open, id, getMail, showToast, onClose]);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <MailIcon color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Reenviar comprobante
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography>
              Se reenviará el comprobante al siguiente correo electrónico:
            </Typography>

            <Typography mt={2} fontWeight="bold" color="primary">
              {mail}
            </Typography>

            <Typography mt={3} color="text.secondary">
              ¿Desea continuar?
            </Typography>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" startIcon={<CloseIcon />} onClick={onClose}>
          Cancelar
        </Button>

        <Button
          variant="contained"
          startIcon={<SendIcon />}
          onClick={handleConfirm}
          disabled={loadingEnviar}
        >
          {loadingEnviar ? "Enviando..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReenviarPorMail;
